import { ValidationSchema } from "@schema-types/types/JourneySchema";
import { ValidationConfig } from "@schema-types/types/ValidationConfig";

export const getValidationConfig = (validation?: ValidationSchema[]) => {
  const regexRule = validation?.find((v) => v.type === "regex");
  const minRule = validation?.find((v) => v.type === "min");
  const maxRule = validation?.find((v) => v.type === "max");
  const minLengthRule = validation?.find((v) => v.type === "minLength");
  const maxLengthRule = validation?.find((v) => v.type === "maxLength");

  const validationConfig: ValidationConfig = {
    pattern: regexRule && {
      value: new RegExp(regexRule.value),
      message: regexRule.message,
    },
    min: minRule && {
      value: minRule.value,
      message: minRule.message,
    },
    max: maxRule && {
      value: maxRule.value,
      message: maxRule.message,
    },
    minLength: minLengthRule && {
      value: minLengthRule.value,
      message: minLengthRule.message,
    },
    maxLength: maxLengthRule && {
      value: maxLengthRule.value,
      message: maxLengthRule.message,
    },
  };
  return validationConfig;
};
